import { Segmented, Table, Tag, Button, Modal, Tooltip } from "antd";
import "bootstrap-icons/font/bootstrap-icons.css";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import {
	countLeaveApplication,
	loadAllLeaveApplication,
	loadLeaveApplicationByStatus,
	reviewLeaveApplication,
} from "../../redux/rtk/features/leave/leaveSlice";
import getPermissions from "../../utils/getPermissions";
import getUserFromToken from "../../utils/getUserFromToken";
import ViewBtn from "../Buttons/ViewBtn";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { GreenLinkBtn } from "../UI/AllLinkBtn";
import BtnAllSvg from "../UI/Button/btnAllSvg";
import BtnViewSvg from "../UI/Button/btnViewSvg";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";
import { useNavigate } from "react-router-dom";
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
function CustomTable({ list, total, EmployeeId }) {
	const dispatch = useDispatch();
	const [status, setStatus] = useState("true");
	const [columnsToShow, setColumnsToShow] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const navigate = useNavigate();

	const columns = [
		{
			id: 1,
			title: "S.No",
			dataIndex: "serial",
			key: "serial",
			width: 80,
			align: "center",
			render: (text) => <span style={{ whiteSpace: "nowrap" }}>{text}</span>,
		},

		{
			id: 2,
			title: " Name",
			key: "EmployeeName",
			dataIndex: "EmployeeName",
			// render: ({ firstName, lastName }) => firstName + " " + lastName,
		},
		{
			id: 3,
			title: "Leave Type",
			dataIndex: "LeaveTypeName",
			key: "LeaveTypeName",
			// render: (leaveType) => leaveType?.leaveType || "N/A"
		},
		{
			id: 4,
			title: "Leave From",
			dataIndex: "StartDate",
			key: "StartDate",
			render: (StartDate) => dayjs(StartDate).format("YYYY-MM-DD"),
		},
		{
			id: 5,
			title: "Leave To",
			dataIndex: "EndDate",
			key: "EndDate",
			render: (EndDate) => dayjs(EndDate).format("YYYY-MM-DD"),
		},
		{
			id: 6,
			title: "Leave Duration",
			dataIndex: "LeaveInDays",
			key: "LeaveInDays",
			width: 120,
			align: "center",
			render: (text) => <span style={{ whiteSpace: "nowrap" }}>{text}</span>,
		},
		{
			id: 7,
			title: "Status",
			dataIndex: "LeaveStatusName",
			key: "LeaveStatusName",
			render: (LeaveStatusName) => {
				if (LeaveStatusName === "Approved") {
					return <Tag color='green'>{LeaveStatusName.toUpperCase()}</Tag>;
				} else if (LeaveStatusName === "Rejected") {
					return <Tag color='red'>{LeaveStatusName.toUpperCase()}</Tag>;
				} else {
					return <Tag color='orange'>{LeaveStatusName.toUpperCase()}</Tag>;
				}
			},
		},

		{
			id: 8,
			title: "Action",
			key: "action",
			// render: ({ EmployeeLeaveId, LeaveStatusName, IsCustomApproved, ApprovedStartDate, ApprovedStartDateDayTypeId, ApprovedEndDate, ApprovedEndDateDayTypeId, ApprovedLeaveInDays }) => {
			render: (record) => {
				const {
					EmployeeLeaveId,
					LeaveStatusName,
					IsCustomApproved,
					ApprovedStartDate,
					ApprovedStartDateDayTypeId,
					ApprovedEndDate,
					ApprovedEndDateDayTypeId,
					ApprovedLeaveInDays,
					IsCustom,
					StartDate,
					StartDateDayTypeId,
					EndDate,
					EndDateDayTypeId,
					LeaveInDays
				} = record;

				const handleApprove = async () => {
					try {
						const resp = await dispatch(
							reviewLeaveApplication({
								//   id: EmployeeLeaveId,
								values: {
									EmployeeLeaveId: EmployeeLeaveId,
									IsCustomApproved: IsCustom,
									LeaveStatusId: 1,
									ApprovedStartDate: StartDate,
									ApprovedStartDateDayTypeId: StartDateDayTypeId,
									ApprovedEndDate: EndDate,
									ApprovedEndDateDayTypeId: EndDateDayTypeId,
									ApprovedLeaveInDays: LeaveInDays,
									DataStatus: 1
								},
							})
						);
						if (resp.payload.message === "success") {
							dispatch(loadAllLeaveApplication({ EmployeeId, page: currentPage, limit: pageSize })); // Refresh the list
						}
					} catch (error) {
						// console.error("Error approving leave:", error);
					}
				};

				const handleReject = async () => {
					try {
						const resp = await dispatch(
							reviewLeaveApplication({
								//   id: EmployeeLeaveId,
								values: {
									EmployeeLeaveId: EmployeeLeaveId,
									IsCustomApproved: IsCustomApproved,
									LeaveStatusId: 0,
									ApprovedStartDate: ApprovedStartDate,
									ApprovedStartDateDayTypeId: ApprovedStartDateDayTypeId,
									ApprovedEndDate: ApprovedEndDate,
									ApprovedEndDateDayTypeId: ApprovedEndDateDayTypeId,
									ApprovedLeaveInDays: ApprovedLeaveInDays,
									DataStatus: 1
								},
							})
						);
						if (resp.payload.message === "success") {
							dispatch(loadAllLeaveApplication({ EmployeeId, page: currentPage, limit: pageSize })); // Refresh the list
						}
					} catch (error) {
						// console.error("Error rejecting leave:", error);
					}
				};

				const handleView = () => {
					navigate(`/admin/leave/${EmployeeLeaveId}`, {
						state: { leaveData: record },
					});
				};
				const handleApproveConfirm = () => {
					Modal.confirm({
						title: 'Do you really want to Accept the leave?',
						onOk: handleApprove,
						okText: 'Yes',
						cancelText: 'No',
					});
				};

				const handleRejectConfirm = () => {
					Modal.confirm({
						title: 'Do you really want to Reject the leave?',
						onOk: handleReject,
						okText: 'Yes',
						cancelText: 'No',
					});
				};

				return (
					<div className="flex gap-2">
						<Tooltip title="View">
							<Button
								type="primary"
								icon={<BtnViewSvg />}
								size="small"
								onClick={handleView}
							/>
						</Tooltip>

						{/* <ViewBtn
							path={`/admin/leave/${EmployeeLeaveId}`}
							text="View"
							icon={<BtnViewSvg />}
			  				/> 
						*/}


						{LeaveStatusName === "Pending" && (
							<>
								<Tooltip title="Approve">
									<Button
										type="primary"
										size="small"
										icon={<CheckOutlined />}
										onClick={handleApproveConfirm}
									/>
								</Tooltip>
								<Tooltip title="Reject">
									<Button
										type="danger"
										size="small"
										icon={<CloseOutlined />}
										onClick={handleRejectConfirm}
									/>
								</Tooltip>
							</>
						)}
					</div>
				);
			},
		},
	];

	//make a onChange function
	const onChange = (value) => {
		setStatus(value);
		setCurrentPage(1); // Reset to first page on filter change
		dispatch(
			loadLeaveApplicationByStatus({ page: 1, limit: pageSize, status: value })
		);
	};

	useEffect(() => {
		setColumnsToShow(columns);
	}, []);

	const columnsToShowHandler = (val) => {
		setColumnsToShow(val);
	};

	const onAllClick = () => {
		setCurrentPage(1); // Reset to first page
		setStatus("all");
		dispatch(loadAllLeaveApplication({ EmployeeId, page: 1, limit: pageSize }));
	};

	// const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));
	const addKeys = (arr) => {
		// console.log('addKeys - currentPage:', currentPage, 'pageSize:', pageSize, 'listLength:', arr?.length);
		
		// If backend returns all items instead of paginated items, slice them on frontend
		const startIndex = (currentPage - 1) * pageSize;
		const endIndex = startIndex + pageSize;
		const paginatedArr = arr.slice(startIndex, endIndex);
		
		// console.log(`Slicing array from index ${startIndex} to ${endIndex}, showing ${paginatedArr.length} items`);
		
		return paginatedArr.map((i, index) => {
			const serial = (currentPage - 1) * pageSize + index + 1;
			// console.log(`Item ${index}: serial = (${currentPage} - 1) * ${pageSize} + ${index} + 1 = ${serial}`);
			return { 
				...i, 
				key: i.EmployeeLeaveId || i.id, 
				serial
			};
		});
	};


	return (
		<div className="get-all-leaves-page-container">
			<div className='ant-card p-4 rounded mt-5 get-all-leaves-card'>
				<div className='flex my-2 justify-between get-all-leaves-header'>
					<div className='w-50'>
						<h4 className='text-xl mb-2'> Leave Applications</h4>
					</div>
				{list && (
					<div className='flex justify-end mr-4'>
						<div className='mt-0.5'>
							<CsvLinkBtn>
								<CSVLink
									data={list}
									className='btn btn-dark btn-sm'
									style={{ marginTop: "5px" }}
									filename='leave_applications'>
									Download CSV
								</CSVLink>
							</CsvLinkBtn>
						</div>

						<div className='ml-2 mt-0.5'>
							<GreenLinkBtn>
								<button onClick={onAllClick}>
									<BtnAllSvg size={15} title={"ALL"} />
								</button>
							</GreenLinkBtn>
						</div>

						<div>
							<Segmented
								className='text-center rounded text-red-500'
								size='middle'
								defaultValue={"ACCEPTED"}
								options={[
									{
										label: (
											<span>
												<i className='bi bi-person-lines-fill'></i> Accepted
											</span>
										),
										value: "ACCEPTED",
									},
									{
										label: (
											<span>
												<i className='bi bi-person-dash-fill'></i> Pending
											</span>
										),
										value: "PENDING",
									},
								]}
								value={status}
								onChange={onChange}
							/>
						</div>
						{list && (
							<div className='ml-2'>
								<ColVisibilityDropdown
									options={columns}
									columns={columns}
									columnsToShowHandler={columnsToShowHandler}
								/>
							</div>
						)}
					</div>
				)}
			</div>
				<Table
					className='text-center'
					scroll={{ x: true, y: "100%" }}
					loading={!list}
				pagination={{
					current: currentPage,
					pageSize: pageSize,
					pageSizeOptions: [10, 20, 50, 100, 200],
					showSizeChanger: true,
					showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
					total: total ? total : 0,
					onChange: (page, newPageSize) => {
						// console.log('Pagination changed - Page:', page, 'PageSize:', newPageSize);
						setCurrentPage(page);
						setPageSize(newPageSize);
						dispatch(loadAllLeaveApplication({ EmployeeId, page, limit: newPageSize }));
					},
				}}
					columns={columnsToShow}
					dataSource={list ? addKeys(list) : []}
				/>
			</div>
		</div>
	);
}

const GetAllLeaves = (props) => {
	const dispatch = useDispatch();
	const list = useSelector((state) => state.leave.list);
	const total = useSelector((state) => state.leave.total);
	const userId = getUserFromToken();
	const EmployeeId = getUserFromToken();
	const permissions = getPermissions();
	const hasPermission = (item) => {
		return permissions?.includes(item ? item : "");
	};

	// console.log("LIST", list);


	// const filteredList = list;
	// const filteredList = list?.filter((item) => item.reportingManagerId === userId);

	// Determine which list to show
	// const dataToShow = hasPermission("show-menu") ? filteredList : list;



	useEffect(() => {
		dispatch(loadAllLeaveApplication({ EmployeeId, page: 1, limit: 10 }));
		dispatch(countLeaveApplication());
	}, []);



	return (
		// <UserPrivateComponent permission={"readAll-leaveApplication"}>
		<div >
			<div >
				<CustomTable list={list} total={total} EmployeeId={EmployeeId} />
				{/*	<CustomTable list={dataToShow} total={total} /> */}
			</div>
		</div>
		// </UserPrivateComponent>
	);
};

export default GetAllLeaves;